"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputFieldDataType = exports.ResourcePropertyType = exports.LogFieldType = exports.FieldDataType = void 0;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
  Example how to create a subset and superset of an enum is taken from here:
  https://devimalplanet.com/typescript-how-to-extend-one-enum-from-another
  Basically you need to create both const and a type to make it work.

  Both LogFieldType and ResourcePropertyType can be used as regular enums:
  - to get enum value: LogFieldType.SIGNATURE
  - to get all available values: Object.values(ResourcePropertyType)
  - to define a type:
    interface MyInterface {
      fieldType: LogFieldType
    }

  The only caveat is when you want to define a type with a specific value,
  in this case you need to add "typeof":

  interface SelectResourceProperty extends ResourceProperty {
    options: string[];
    type: typeof ResourcePropertyType.SINGLE_SELECT;
  }

  Another inconvenience is that IDE hints might not be very friendly:
  Instead of saying that "Property USER doesn't exist on type ResourcePropertyType",
  it will say that "Property USER doesn't exist on type { readonly BOOLEAN: "boolean"; ... }"
*/
var FieldDataType; // Don't forget to exclude options from both const and type

exports.FieldDataType = FieldDataType;

(function (FieldDataType) {
  FieldDataType["BOOLEAN"] = "boolean";
  FieldDataType["DATE"] = "date";
  FieldDataType["DATETIME"] = "datetime";
  FieldDataType["FORMULA"] = "formula";
  FieldDataType["LOCATION"] = "location";
  FieldDataType["NUMERIC"] = "numeric";
  FieldDataType["PARAMETER"] = "parameter";
  FieldDataType["RESOURCE"] = "resource";
  FieldDataType["SIGNATURE"] = "signature";
  FieldDataType["SINGLE_SELECT"] = "singleSelect";
  FieldDataType["SUBSTANCE"] = "substance";
  FieldDataType["TEXT"] = "text";
  FieldDataType["TIME"] = "time";
  FieldDataType["USER"] = "user";
})(FieldDataType || (exports.FieldDataType = FieldDataType = {}));

var LogFieldTypeConst = Object.assign({}, FieldDataType);
var LogFieldType = LogFieldTypeConst;
exports.LogFieldType = LogFieldType;

// Don't forget to exclude options from both const and type
var DATE = FieldDataType.DATE,
    FORMULA = FieldDataType.FORMULA,
    LOCATION = FieldDataType.LOCATION,
    SIGNATURE = FieldDataType.SIGNATURE,
    TIME = FieldDataType.TIME,
    USER = FieldDataType.USER,
    ResourcePropertyTypeConst = _objectWithoutProperties(FieldDataType, ["DATE", "FORMULA", "LOCATION", "SIGNATURE", "TIME", "USER"]);

var ResourcePropertyType = ResourcePropertyTypeConst;
exports.ResourcePropertyType = ResourcePropertyType;

// Don't forget to exclude options from both const & type
var _ = FieldDataType.FORMULA,
    InputFieldDataTypeConst = _objectWithoutProperties(FieldDataType, ["FORMULA"]);

var InputFieldDataType = InputFieldDataTypeConst;
exports.InputFieldDataType = InputFieldDataType;